// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"f08e9c85","527":"641a797c"}[chunkId] + ".chunk.js";
};